import {
  Badge,
  Box,
  Divider,
  Heading,
  HStack,
  ListItem,
  Text,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import { Section } from "./tos.constants";

const SectionBlock = ({ section }: { section: Section }) => {
  return (
    <Box id={section.id} as="section">
      <HStack gap={3} mb={5} alignItems="center">
        <Badge
          colorScheme="blue"
          variant="subtle"
          fontSize="xs"
          fontWeight="700"
          letterSpacing="wider"
          px={2}
          py={1}
          borderRadius="md"
          fontFamily="mono"
        >
          {section.number}
        </Badge>
        <Heading
          as="h2"
          fontSize={{ base: "lg", md: "xl" }}
          fontWeight="700"
          color="gray.900"
          _dark={{ color: "gray.50" }}
          letterSpacing="-0.01em"
        >
          {section.title}
        </Heading>
      </HStack>

      <VStack gap={4} alignItems="stretch" pl={{ base: 0, md: 8 }}>
        {section.subsections.map((sub, i) => (
          <Box key={i}>
            <Text
              as="span"
              fontWeight="600"
              fontSize="sm"
              color="blue.700"
              _dark={{ color: "blue.300" }}
              display="inline"
            >
              {sub.label}.{" "}
            </Text>
            <Text
              as="span"
              fontSize={sub.isAllCaps ? "xs" : "sm"}
              lineHeight="1.8"
              color="gray.700"
              _dark={{ color: "gray.300" }}
              fontFamily={sub.isAllCaps ? "mono" : "body"}
            >
              {sub.text}
            </Text>
            {sub.list && (
              <UnorderedList>
                {sub.list.map((item, idx) => (
                  <ListItem
                    key={idx}
                    fontSize="sm"
                    color="gray.700"
                    _dark={{ color: "gray.300" }}
                    lineHeight="1.8"
                  >
                    {item}
                  </ListItem>
                ))}
              </UnorderedList>
            )}
          </Box>
        ))}
      </VStack>

      <Divider mt={8} borderColor="gray.100" _dark={{ borderColor: "gray.800" }} />
    </Box>
  );
};

export default SectionBlock;
